import { KebabHorizontalIcon, PencilIcon, PlusIcon, SyncIcon, TrashIcon } from '@primer/octicons-react';
import { ActionList, ActionMenu, Box, Checkbox, useConfirm } from '@primer/react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/ui/button';
import DataTable from '../../../components/ui/data-table';
import { useCommonContext } from '../../../contexts/common';
import { actions } from '../../../state/actions/actionsWrapper';
import { RootState } from '../../../state/reducers';
import LegalGroupEditModal from './LegalGroupEditModal';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { useEffect } from 'react';
import { ILegalGroup } from '../../../models/response/legal-document/ILegalGroup';
import Text from '../../../components/ui/text';

const LegalGroupPage = () => {
    const { status, groups, isShowEditModal } = useSelector((x: RootState) => x.legalDocument.group)
    const { translate } = useCommonContext();
    const confirm = useConfirm();
    const dispatch = useDispatch();
    useEffect(() => {
        if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
            dispatch(actions.legalDocument.group.LOAD_START(undefined))
        }
    }, [status])
    const handleDelete = async (id: number) => {
        if (await confirm({
            content: translate(`Base.Label.Confirm.Delete.Content`),
            title: translate(`Base.Label.Confirm.Delete.Title`),
            cancelButtonContent: translate(`Base.Label.Confirm.Delete.Cancel`),
            confirmButtonContent: translate(`Base.Label.Confirm.Delete.Confirm`),
            confirmButtonType: "danger",
        })) {
            dispatch(actions.legalDocument.group.DELETE_START(id))
        }
    }
    return (
        <Box sx={{ p: 3 }}>
            <DataTable
                title={translate(`LegalGroupPage.Caption`)}
                data={groups}
                columns={[
                    {
                        dataField: "name",
                        caption: translate(`LegalGroup.Name`),
                        // isMainColumn: true,
                        cellRender: (data: ILegalGroup) => {
                            return (
                                <Box>
                                    <Box sx={{ fontWeight: 600 }}>{data.name}</Box>
                                    <Box><i>{data.name_en}</i></Box>
                                </Box>
                            );
                        }
                    },
                    {
                        dataField: "is_active",
                        align: "center",
                        width: "100px",
                        caption: translate(`LegalGroup.IsActive`),
                        cellRender: (data: ILegalGroup) => {
                            return <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <Checkbox checked={data.is_active} />
                            </Box>
                        }
                    },
                    {
                        id: "cmd",
                        align: "center",
                        width: "50px",
                        caption: translate(``),
                        cellRender: (data: ILegalGroup) => {
                            return <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <ActionMenu>
                                    <ActionMenu.Button icon={KebabHorizontalIcon} variant='invisible'>&nbsp;</ActionMenu.Button>
                                    <ActionMenu.Overlay>
                                        <ActionList>
                                            <ActionList.Item onSelect={() => {
                                                dispatch(actions.legalDocument.group.SHOW_EDIT_MODAL(data))
                                            }}>
                                                <ActionList.LeadingVisual><PencilIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Edit' />
                                            </ActionList.Item>
                                            <ActionList.Divider />
                                            <ActionList.Item variant='danger' onSelect={() => {
                                                handleDelete(data.id)
                                            }}>
                                                <ActionList.LeadingVisual><TrashIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Delete' />
                                            </ActionList.Item>
                                        </ActionList>
                                    </ActionMenu.Overlay>
                                </ActionMenu>
                            </Box>
                        }
                    },
                ]}
                // searchEnable
                isLoading={status === ePageBaseStatus.is_loading}
                actionComponent={
                    <Box sx={{ display: "flex" }}>
                        <Button text='Base.Label.Refresh'
                            size='medium'
                            leadingVisual={SyncIcon}
                            onClick={() => {
                                dispatch(actions.legalDocument.group.LOAD_START(undefined))
                            }}
                        />
                        <Button text='Base.Label.AddNew'
                            variant='primary'
                            size='medium'
                            leadingVisual={PlusIcon}
                            sx={{ ml: 1 }}
                            onClick={() => {
                                dispatch(actions.legalDocument.group.SHOW_EDIT_MODAL(undefined))
                            }}
                        />
                    </Box>
                }
            />
            {isShowEditModal &&
                <LegalGroupEditModal />
            }
        </Box>
    );
};

export default LegalGroupPage;